<template>
  <div ref="chartRoot">
    <div class="row-charts row-charts--half">
      <div class="card analysis-chart" data-chart-key="trend">
        <v-progress-linear v-if="loading.trend" class="card-loading" color="primary" height="2" indeterminate />
        <div class="card-head"><span class="card-head__title"><span class="chart-order">01</span>告警趋势</span><span
            class="sub">按分类逐日统计（单位：条）</span></div>
        <div ref="trendChartRef" class="chart-box" />
      </div>
      <div class="card analysis-chart" data-chart-key="hour-distribution">
        <v-progress-linear v-if="loading.hourly" class="card-loading" color="primary" height="2" indeterminate />
        <div class="card-head"><span class="card-head__title"><span class="chart-order">02</span>时段热力</span><span
            class="sub">24小时告警分布（单位：条）</span></div>
        <div ref="hourDistChartRef" class="chart-box" />
      </div>
    </div>

    <div class="row-charts">
      <div class="card analysis-chart" data-chart-key="top-alarms">
        <v-progress-linear v-if="loading.topAlarms" class="card-loading" color="primary" height="2" indeterminate />
        <div class="card-head"><span class="card-head__title"><span class="chart-order">03</span>高频告警</span><span
            class="sub">触发次数 Top 8</span></div>
        <div class="cluster-chart">
          <div v-for="item in topAlarms" :key="item.code" class="cluster-block">
            <div class="cluster-row">
              <div class="cluster-label-group">
                <div class="cluster-main-label">
                  <v-icon size="14" :class="'cat-' + item.cat.toLowerCase()" class="cluster-cat-icon">{{
                    CAT_ICON[item.cat]
                  }}</v-icon>
                  <span class="alarm-code" :style="{ color: CAT_COLORS[item.cat] }">{{ item.code }}</span>
                  <span class="alarm-desc">{{ item.name }}</span>
                </div>
              </div>
              <div class="cluster-visual">
                <div class="visual-bar-area">
                  <div class="bar-track">
                    <div class="bar-fill" :style="{ width: (item.count / maxTopAlarmCount * 100) + '%' }">
                      <span class="bar-label">{{ item.count }}次</span>
                    </div>
                  </div>
                </div>
                <div class="visual-stats">
                  <span class="stat-badge neutral">{{ item.stations }}站</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card analysis-chart" data-chart-key="equipment-distribution">
        <v-progress-linear v-if="loading.deviceTypes" class="card-loading" color="primary" height="2" indeterminate />
        <div class="card-head"><span class="card-head__title"><span class="chart-order">04</span>设备类型分布</span><span
            class="sub">各设备类型对比（单位：条）</span></div>
        <div ref="equipTypeChartRef" class="chart-box" />
      </div>
    </div>

    <div v-if="isMultiStation" class="row-charts">
      <div class="card analysis-chart" data-chart-key="eblock-models">
        <v-progress-linear v-if="loading.eblockModels" class="card-loading" color="primary" height="2" indeterminate />
        <div class="card-head"><span class="card-head__title"><span class="chart-order">05</span>eBlock
            型号对比</span><span class="sub">各型号告警堆叠对比（单位：条）</span></div>
        <div ref="eblockChartRef" class="chart-box chart-box--eblock" />
      </div>
      <div class="card analysis-chart" data-chart-key="station-ranking">
        <v-progress-linear v-if="loading.stations" class="card-loading" color="primary" height="2" indeterminate />
        <div class="card-head"><span class="card-head__title"><span class="chart-order">06</span>电站告警排名</span><span
            class="sub">告警数量排名 Top 10（单位：条）</span></div>
        <div ref="stationRankChartRef" class="chart-box chart-box--eblock" />
      </div>
    </div>

    <div v-else class="row-charts row-charts--full">
      <DeviceAlarmMatrix class="analysis-chart" data-chart-key="station-device-alarm"
        :devices="stationDeviceData" :station-name="stationName" :loading="loading.stationDevices" />
    </div>

    <div v-if="isMultiStation" class="row-charts row-charts--full">
      <div class="card geo-card analysis-chart" data-chart-key="region-distribution">
        <v-progress-linear v-if="loading.regions" class="card-loading" color="primary" height="2" indeterminate />
        <div class="card-head"><span class="card-head__title"><span class="chart-order">07</span>地域分布</span><span
            class="sub">省级告警热力</span></div>
        <div class="geo-card__body">
          <div ref="provinceChartRef" class="geo-card__map" />
          <div class="geo-card__rank">
            <div class="rank-list">
              <div class="rank-table">
                <div class="rank-header">
                  <span class="rank-header__col">排名</span>
                  <span class="rank-header__col rank-header__col--name">省份</span>
                  <span class="rank-header__col rank-header__col--bar">告警量</span>
                  <span class="rank-header__col rank-header__col--num">总数</span>
                  <span class="rank-header__col rank-header__col--cat">安全</span>
                  <span class="rank-header__col rank-header__col--cat">收益</span>
                  <span class="rank-header__col rank-header__col--cat">普通</span>
                  <span class="rank-header__col">电站</span>
                </div>
                <div v-for="(item, idx) in provinceRank" :key="item.name" class="province-row"
                  :class="{ 'is-highlight': highlightProvince === item.name }"
                  @mouseenter="onProvinceRowHover(item.name)" @mouseleave="onProvinceRowHover(null)">
                  <span class="province-row__rank-cell">
                    <span class="province-row__rank" :class="{ 'is-top': idx < 3 }">{{ idx + 1 }}</span>
                  </span>
                  <span class="province-row__name">{{ item.name }}</span>
                  <div class="province-row__bar-cell">
                    <div class="province-row__bar-wrap">
                      <div class="province-row__bar" :style="{ width: item.pct + '%' }" />
                    </div>
                  </div>
                  <span class="province-row__total">{{ item.total }}</span>
                  <span class="province-row__safety">{{ item.safety }}</span>
                  <span class="province-row__income">{{ item.income }}</span>
                  <span class="province-row__normal">{{ item.normal }}</span>
                  <span class="province-row__stations">{{ item.stations }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, nextTick, onMounted, onUnmounted, watch } from 'vue'
import * as echarts from 'echarts'
import dayjs from 'dayjs'
import chinaGeoJson from '@/assets/json/china.json'
import DeviceAlarmMatrix from './DeviceAlarmMatrix.vue'

const props = defineProps({
  isMultiStation: { type: Boolean, required: true },
  stationName: { type: String, default: '' },
  trendSource: { type: Array, default: () => [] },
  hourlySource: { type: Array, default: () => [] },
  topAlarmSource: { type: Array, default: () => [] },
  deviceTypeSource: { type: Array, default: () => [] },
  eblockSource: { type: Array, default: () => [] },
  stationRankSource: { type: Array, default: () => [] },
  regionSource: { type: Array, default: () => [] },
  stationDeviceSource: { type: Array, default: () => [] },
  loading: { type: Object, required: true },
})

const CAT_COLORS = { SAFETY: '#FF1E1E', INCOME: '#F59E0B', NORMAL: '#3A68FF' }
const CAT_ICON = { SAFETY: 'mdi-fire-alert', INCOME: 'mdi-lightbulb-alert-outline', NORMAL: 'mdi-bell-alert-outline' }
const toCount = value => Number(value) || 0

const trendData = computed(() => props.trendSource.map(item => ({
  date: dayjs(item.date).isValid() ? dayjs(item.date).format('MM-DD') : item.date,
  safety: toCount(item.safety),
  income: toCount(item.income),
  normal: toCount(item.normal),
})))

const topAlarms = computed(() => props.topAlarmSource
  .map(item => ({
    code: item.alarmCode || '-',
    name: item.description || '-',
    count: toCount(item.triggerCount),
    stations: toCount(item.stationCount),
    cat: String(item.category || 'NORMAL').toUpperCase(),
  }))
  .sort((a, b) => b.count - a.count)
  .slice(0, 8))
const maxTopAlarmCount = computed(() => topAlarms.value[0]?.count || 1)

function getEquipmentTypeName(item) {
  const type = item.typeName || item.type || '-'
  return String(type) === '00' ? '默认' : type
}

const equipmentData = computed(() => props.deviceTypeSource.map(item => ({
  type: getEquipmentTypeName(item),
  SAFETY: toCount(item.safety),
  INCOME: toCount(item.income),
  NORMAL: toCount(item.normal),
})))

const eblockData = computed(() => props.eblockSource.map(item => ({
  model: item.productModel || '-',
  SAFETY: toCount(item.safety),
  INCOME: toCount(item.income),
  NORMAL: toCount(item.normal),
})))

const stationRankData = computed(() => props.stationRankSource
  .map(item => ({
    name: item.stationName || String(item.stationId || '-'),
    total: toCount(item.total),
    SAFETY: toCount(item.safety),
    INCOME: toCount(item.income),
    NORMAL: toCount(item.normal),
  }))
  .sort((a, b) => b.total - a.total)
  .slice(0, 10))

const regionData = computed(() => props.regionSource.map(item => ({
  name: item.province || '-',
  total: toCount(item.total),
  safety: toCount(item.safety),
  income: toCount(item.income),
  normal: toCount(item.normal),
  stations: toCount(item.stationCount),
})))

const hourlyData = computed(() => props.hourlySource.map(item => ({
  hour: String(item.hour).padStart(2, '0'),
  safety: toCount(item.safety),
  income: toCount(item.income),
  normal: toCount(item.normal),
})))

const stationDeviceData = computed(() => props.stationDeviceSource
  .map((item, index) => ({
    id: item.equipmentId || item.deviceId || item.equipmentCode || item.deviceCode || index,
    name: item.equipmentName || item.deviceName || String(item.equipmentId || item.deviceId || '-'),
    code: item.equipmentCode || item.deviceCode || String(item.equipmentId || item.deviceId || '-'),
    total: toCount(item.total),
    SAFETY: toCount(item.safety),
    INCOME: toCount(item.income),
    NORMAL: toCount(item.normal),
  }))
  .sort((a, b) => b.total - a.total))

const provinceRank = computed(() => {
  const sorted = [...regionData.value].sort((a, b) => b.total - a.total)
  const max = sorted[0]?.total || 1
  return sorted.map(item => ({ ...item, pct: Math.round((item.total / max) * 100) }))
})

const chartRoot = ref(null)
const trendChartRef = ref(null)
const equipTypeChartRef = ref(null)
const provinceChartRef = ref(null)
const eblockChartRef = ref(null)
const stationRankChartRef = ref(null)
const hourDistChartRef = ref(null)
const highlightProvince = ref(null)

const chartInstances = new Map()
const renderFrames = new Map()
let provinceChart = null
let resizeObserver = null
let focusTimer = null
let chinaGeoLoaded = false

function chartPalette() {
  const root = document.documentElement
  const host = chartRoot.value
  const read = (element, name, fallback) => {
    if (!element) return fallback
    return getComputedStyle(element).getPropertyValue(name).trim() || fallback
  }
  return {
    primary: read(root, '--color-primary', '#2B57EE'),
    axisMuted: read(host, '--chart-axis-label', '#7a8199'),
    split: read(host, '--chart-split-line', '#edf2f6'),
  }
}

function ensureChinaGeo() {
  if (chinaGeoLoaded) return
  echarts.registerMap('china', chinaGeoJson)
  chinaGeoLoaded = true
}

function onProvinceRowHover(name) {
  highlightProvince.value = name
  if (!provinceChart) return
  if (name) {
    provinceChart.dispatchAction({ type: 'highlight', seriesIndex: 0, name })
    provinceChart.dispatchAction({ type: 'showTip', seriesIndex: 0, name })
  } else {
    provinceChart.dispatchAction({ type: 'downplay', seriesIndex: 0 })
    provinceChart.dispatchAction({ type: 'hideTip' })
  }
}

function onMapHover(name) {
  highlightProvince.value = name
  if (name) {
    chartRoot.value?.querySelector('.province-row.is-highlight')
      ?.scrollIntoView?.({ block: 'nearest', behavior: 'smooth' })
  }
}

function disposeChart(key) {
  const chart = chartInstances.get(key)
  chart?.dispose()
  chartInstances.delete(key)
  if (key === 'province') provinceChart = null
}

function getChart(key, element) {
  const current = chartInstances.get(key)
  if (!element) {
    disposeChart(key)
    return { chart: null, created: false }
  }
  if (current && !current.isDisposed() && current.getDom() === element) {
    return { chart: current, created: false }
  }
  disposeChart(key)
  const chart = echarts.init(element)
  chartInstances.set(key, chart)
  return { chart, created: true }
}

function baseAxisOption(axisMuted, split) {
  return { axisLabel: { color: axisMuted, fontSize: 11 }, splitLine: { lineStyle: { color: split } } }
}

function renderTrendChart() {
  const { axisMuted, split } = chartPalette()
  const baseAxis = baseAxisOption(axisMuted, split)
  const { chart } = getChart('trend', trendChartRef.value)
  if (!chart) return
  const data = trendData.value
  chart.setOption({
    tooltip: { trigger: 'axis' },
    legend: { data: ['影响安全', '影响收益', '普通告警'], top: 0, right: 0, textStyle: { fontSize: 11 } },
    grid: { left: '3%', right: '4%', bottom: '3%', top: '36px', containLabel: true },
    xAxis: { type: 'category', data: data.map(item => item.date), ...baseAxis, boundaryGap: false },
    yAxis: { type: 'value', ...baseAxis },
    series: [
      { name: '影响安全', type: 'line', smooth: true, data: data.map(item => item.safety), itemStyle: { color: CAT_COLORS.SAFETY }, lineStyle: { width: 2 }, areaStyle: { color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: 'rgba(255,30,30,0.15)' }, { offset: 1, color: 'rgba(255,30,30,0)' }]) } },
      { name: '影响收益', type: 'line', smooth: true, data: data.map(item => item.income), itemStyle: { color: CAT_COLORS.INCOME }, lineStyle: { width: 2 }, areaStyle: { color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: 'rgba(245,158,11,0.15)' }, { offset: 1, color: 'rgba(245,158,11,0)' }]) } },
      { name: '普通告警', type: 'line', smooth: true, data: data.map(item => item.normal), itemStyle: { color: CAT_COLORS.NORMAL }, lineStyle: { width: 2 }, areaStyle: { color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: 'rgba(58,104,255,0.1)' }, { offset: 1, color: 'rgba(58,104,255,0)' }]) } },
    ],
  }, { notMerge: true })
}

function renderEquipmentChart() {
  const { axisMuted, split } = chartPalette()
  const { chart } = getChart('equipment', equipTypeChartRef.value)
  if (!chart) return
  const data = equipmentData.value
  const max = Math.max(1, ...data.flatMap(item => [item.SAFETY, item.INCOME, item.NORMAL]))
  chart.setOption({
      tooltip: { trigger: 'item', confine: true },
      legend: { data: ['影响安全', '影响收益', '普通告警'], top: 0, right: 0, textStyle: { fontSize: 11 } },
      radar: {
        indicator: data.map(item => ({ name: item.type, max })),
        center: ['50%', '55%'],
        radius: '65%',
        axisName: { color: axisMuted, fontSize: 11 },
        splitArea: { areaStyle: { color: ['rgba(43,87,238,0.02)', 'rgba(43,87,238,0.05)'] } },
        splitLine: { lineStyle: { color: split } },
        axisLine: { lineStyle: { color: split } },
      },
      series: [{
        type: 'radar',
        symbolSize: 5,
        data: [
          { name: '普通告警', value: data.map(item => item.NORMAL), lineStyle: { color: CAT_COLORS.NORMAL, width: 2 }, itemStyle: { color: CAT_COLORS.NORMAL }, areaStyle: { color: 'rgba(58,104,255,0.1)' } },
          { name: '影响收益', value: data.map(item => item.INCOME), lineStyle: { color: CAT_COLORS.INCOME, width: 2 }, itemStyle: { color: CAT_COLORS.INCOME }, areaStyle: { color: 'rgba(245,158,11,0.12)' } },
          { name: '影响安全', value: data.map(item => item.SAFETY), lineStyle: { color: CAT_COLORS.SAFETY, width: 2 }, itemStyle: { color: CAT_COLORS.SAFETY }, areaStyle: { color: 'rgba(255,30,30,0.12)' } },
        ],
      }],
  }, { notMerge: true })
}

function renderProvinceChart() {
  if (!props.isMultiStation) {
    disposeChart('province')
    return
  }
  const { axisMuted } = chartPalette()
  ensureChinaGeo()
  const { chart, created } = getChart('province', provinceChartRef.value)
  if (!chart) return
  provinceChart = chart
  const data = regionData.value
  const max = Math.max(1, ...data.map(item => item.total))
  chart.setOption({
    tooltip: {
      trigger: 'item', formatter: params => {
        if (typeof params.value !== 'number' || isNaN(params.value)) return `${params.name}<br/>暂无数据`
        const item = data.find(row => row.name === params.name)
        if (!item) return `${params.name}<br/>告警数：${params.value}`
        return `${params.name}<br/>告警总数：${item.total}<br/><span style="color:${CAT_COLORS.SAFETY}">影响安全：${item.safety}</span><br/><span style="color:${CAT_COLORS.INCOME}">影响收益：${item.income}</span><br/><span style="color:${CAT_COLORS.NORMAL}">普通告警：${item.normal}</span><br/>涉及电站：${item.stations}`
      }
    },
    visualMap: {
      min: 0, max, left: 6, bottom: 6, itemHeight: 80, text: ['高', '低'],
      inRange: { color: ['#dce8ff', chartPalette().primary] },
      textStyle: { color: axisMuted, fontSize: 10 },
    },
    series: [{
      type: 'map', map: 'china', roam: false, layoutCenter: ['50%', '65%'], layoutSize: '120%',
      data: data.map(item => ({ name: item.name, value: item.total })),
      emphasis: { label: { show: true, fontSize: 12 }, itemStyle: { areaColor: 'inherit', borderColor: '#FFF', borderWidth: 2 } },
      itemStyle: { borderColor: '#fff', borderWidth: 0.5 },
      label: { show: false },
      select: { label: { show: true }, itemStyle: { areaColor: 'inherit', borderColor: '#FFF', borderWidth: 2 } },
    }],
  }, { notMerge: true })
  if (created) {
    chart.on('mouseover', params => { if (params.componentType === 'series') onMapHover(params.name) })
    chart.on('mouseout', () => onMapHover(null))
  }
}

function renderStationRankChart() {
  if (!props.isMultiStation) {
    disposeChart('stationRank')
    return
  }
  const { axisMuted, split } = chartPalette()
  const baseAxis = baseAxisOption(axisMuted, split)
  const { chart } = getChart('stationRank', stationRankChartRef.value)
  if (!chart) return
  const data = [...stationRankData.value].reverse()
  chart.setOption({
      tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
      legend: { data: ['影响安全', '影响收益', '普通告警'], top: 0, right: 0, textStyle: { fontSize: 11 } },
      grid: { left: '3%', right: '4%', bottom: '3%', top: '36px', containLabel: true },
      xAxis: { type: 'value', ...baseAxis },
      yAxis: { type: 'category', data: data.map(item => item.name), axisLabel: { color: axisMuted, fontSize: 11, width: 140, overflow: 'truncate' } },
      series: [
        { name: '影响安全', type: 'bar', stack: 'total', barWidth: '60%', data: data.map(item => item.SAFETY), itemStyle: { color: CAT_COLORS.SAFETY } },
        { name: '影响收益', type: 'bar', stack: 'total', barWidth: '60%', data: data.map(item => item.INCOME), itemStyle: { color: CAT_COLORS.INCOME } },
        { name: '普通告警', type: 'bar', stack: 'total', barWidth: '60%', data: data.map(item => item.NORMAL), itemStyle: { color: CAT_COLORS.NORMAL, borderRadius: [0, 4, 4, 0] } },
      ],
  }, { notMerge: true })
}

function renderEblockChart() {
  if (!props.isMultiStation) {
    disposeChart('eblock')
    return
  }
  const { axisMuted, split } = chartPalette()
  const baseAxis = baseAxisOption(axisMuted, split)
  const { chart } = getChart('eblock', eblockChartRef.value)
  if (!chart) return
  const data = eblockData.value
  chart.setOption({
    tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
    legend: { data: ['影响安全', '影响收益', '普通告警'], top: 0, right: 0, textStyle: { fontSize: 11 } },
    grid: { left: '3%', right: '4%', bottom: '4%', top: '36px', containLabel: true },
    xAxis: { type: 'category', data: data.map(item => item.model), ...baseAxis, axisLabel: { ...baseAxis.axisLabel, rotate: 40, fontSize: 10, interval: 0 } },
    yAxis: { type: 'value', ...baseAxis },
    series: [
      { name: '影响安全', type: 'bar', stack: 'total', barWidth: '40%', data: data.map(item => item.SAFETY), itemStyle: { color: CAT_COLORS.SAFETY } },
      { name: '影响收益', type: 'bar', stack: 'total', barWidth: '40%', data: data.map(item => item.INCOME), itemStyle: { color: CAT_COLORS.INCOME } },
      { name: '普通告警', type: 'bar', stack: 'total', barWidth: '40%', data: data.map(item => item.NORMAL), itemStyle: { color: CAT_COLORS.NORMAL, borderRadius: [4, 4, 0, 0] } },
    ],
  }, { notMerge: true })
}

function renderHourlyChart() {
  const { axisMuted, split } = chartPalette()
  const baseAxis = baseAxisOption(axisMuted, split)
  const { chart } = getChart('hourly', hourDistChartRef.value)
  if (!chart) return
  const data = hourlyData.value
  const categories = ['影响安全', '影响收益', '普通告警']
  const categoryKeys = ['safety', 'income', 'normal']
  const hours = data.map(item => item.hour + ':00')
  const heatData = []
  const values = []
  data.forEach((item, xIndex) => {
    categoryKeys.forEach((key, yIndex) => {
      heatData.push([xIndex, yIndex, item[key]])
      values.push(item[key])
    })
  })
  chart.setOption({
    tooltip: { formatter: params => `${hours[params.value[0]]}<br/>${categories[params.value[1]]}：${params.value[2]}` },
    grid: { left: '3%', right: '6%', bottom: '3%', top: '8px', containLabel: true },
    xAxis: { type: 'category', data: hours, ...baseAxis, splitArea: { show: true, areaStyle: { color: ['rgba(0,0,0,0)', 'rgba(0,0,0,0.01)'] } } },
    yAxis: { type: 'category', data: categories, axisLabel: { color: axisMuted, fontSize: 11 }, splitArea: { show: false } },
    visualMap: { min: 0, max: Math.max(1, ...values), show: false, inRange: { color: ['#eef3ff', '#97b6f8', '#4d7ef7', '#2655ee', '#1a3dbb'] } },
    series: [{ type: 'heatmap', data: heatData, itemStyle: { borderColor: '#fff', borderWidth: 2, borderRadius: 4 }, emphasis: { itemStyle: { borderColor: '#333', borderWidth: 2 } } }],
  }, { notMerge: true })
}

function disposeCharts() {
  chartInstances.forEach(chart => chart?.dispose())
  chartInstances.clear()
  provinceChart = null
}

function scheduleRender(key, render) {
  nextTick(() => {
    const pendingFrame = renderFrames.get(key)
    if (pendingFrame) cancelAnimationFrame(pendingFrame)
    const frame = requestAnimationFrame(() => {
      renderFrames.delete(key)
      render()
    })
    renderFrames.set(key, frame)
  })
}

function renderAllCharts() {
  renderTrendChart()
  renderHourlyChart()
  renderEquipmentChart()
  renderEblockChart()
  renderStationRankChart()
  renderProvinceChart()
}

function resize() {
  chartInstances.forEach(chart => chart?.resize())
}

function focusChart(chartKey) {
  const keyMap = {
    hourly: 'hour-distribution',
    topAlarms: 'top-alarms',
    deviceTypes: 'equipment-distribution',
    stationDevices: 'station-device-alarm',
    stationDeviceAlarm: 'station-device-alarm',
    eblockModels: 'eblock-models',
    stations: 'station-ranking',
    regions: 'region-distribution',
  }
  const targetKey = keyMap[chartKey] || chartKey
  const target = [...(chartRoot.value?.querySelectorAll('[data-chart-key]') || [])]
    .find(element => element.dataset.chartKey === targetKey)
  if (!target) return

  if (focusTimer) window.clearTimeout(focusTimer)
  chartRoot.value?.querySelector('.analysis-chart.is-analysis-focus')?.classList.remove('is-analysis-focus')
  target.classList.remove('is-analysis-focus')
  void target.offsetWidth
  target.classList.add('is-analysis-focus')
  target.scrollIntoView({ behavior: 'smooth', block: 'start' })
  focusTimer = window.setTimeout(() => {
    target.classList.remove('is-analysis-focus')
    focusTimer = null
  }, 1600)
}

function waitAndInit() {
  if (resizeObserver) resizeObserver.disconnect()
  const element = trendChartRef.value
  if (!element) return
  const tryInit = () => {
    if (element.clientWidth <= 0) return false
    resizeObserver?.disconnect()
    resizeObserver = null
    renderAllCharts()
    requestAnimationFrame(resize)
    return true
  }
  if (tryInit()) return
  resizeObserver = new ResizeObserver(() => tryInit())
  resizeObserver.observe(element)
}

watch(() => props.trendSource, () => scheduleRender('trend', renderTrendChart))
watch(() => props.hourlySource, () => scheduleRender('hourly', renderHourlyChart))
watch(() => props.deviceTypeSource, () => scheduleRender('equipment', renderEquipmentChart))
watch(() => [props.isMultiStation, props.eblockSource], () => scheduleRender('eblock', renderEblockChart))
watch(() => [props.isMultiStation, props.stationRankSource], () => scheduleRender('stationRank', renderStationRankChart))
watch(() => [props.isMultiStation, props.regionSource], () => scheduleRender('province', renderProvinceChart))

onMounted(() => {
  nextTick(() => requestAnimationFrame(waitAndInit))
  window.addEventListener('resize', resize)
})

onUnmounted(() => {
  renderFrames.forEach(frame => cancelAnimationFrame(frame))
  renderFrames.clear()
  if (focusTimer) window.clearTimeout(focusTimer)
  resizeObserver?.disconnect()
  disposeCharts()
  window.removeEventListener('resize', resize)
})

defineExpose({ focusChart, resize })
</script>

<style scoped lang="scss">
.row-charts {
  display: grid;
  grid-template-columns: 3fr 2fr;
  gap: 14px;
  margin-bottom: 14px;
}

.row-charts--half {
  grid-template-columns: 1fr 1fr;
}

.row-charts--full {
  grid-template-columns: 1fr;
}

.geo-card__body {
  display: flex;
  gap: 0;
  flex: 1;
}

.geo-card__map {
  width: 50%;
  flex-shrink: 0;
  height: 600px;
}

.geo-card__rank {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  border-left: 1px solid var(--border);
  padding-left: 16px;
}

.rank-header {
  display: table-row;

  &__col {
    display: table-cell;
    position: sticky;
    top: 0;
    z-index: 1;
    background: rgba(255, 255, 255, 0.96);
    backdrop-filter: blur(6px);
    font-size: 11px;
    color: var(--text-muted);
    font-weight: 500;
    text-align: center;
    white-space: nowrap;
    padding: 6px 4px 8px;
    border-bottom: 1px solid var(--border);
  }

  &__col--name,
  &__col--bar {
    text-align: left;
  }

  &__col--bar {
    width: 100%;
  }

  &__col--num {
    text-align: right;
  }
}

.rank-list {
  flex: 1;
  overflow-y: auto;
  overflow-x: auto;
}

.rank-table {
  display: table;
  width: 100%;
  border-spacing: 0 2px;
}

.province-row {
  display: table-row;
  cursor: default;

  >* {
    display: table-cell;
    vertical-align: middle;
    padding: 5px 4px;
    transition: background 0.15s;
  }

  >:first-child {
    padding-left: 10px;
    border-radius: 6px 0 0 6px;
  }

  >:last-child {
    padding-right: 10px;
    border-radius: 0 6px 6px 0;
  }

  &:hover>*,
  &.is-highlight>* {
    background: var(--primary-faint);
  }

  &__rank {
    width: 22px;
    height: 22px;
    border-radius: 6px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 600;
    color: var(--text-muted);
    background: var(--surface-muted);

    &.is-top {
      background: linear-gradient(135deg, var(--primary), #48a9a6);
      color: #fff;
    }
  }

  &__name {
    width: 44px;
    font-size: 13px;
    font-weight: 500;
    color: var(--text-primary);
    white-space: nowrap;
  }

  &__bar-cell {
    width: 100%;
  }

  &__bar-wrap {
    height: 8px;
    background: var(--surface-muted);
    border-radius: 4px;
    overflow: hidden;
    min-width: 40px;
  }

  &__bar {
    height: 100%;
    border-radius: 4px;
    background: linear-gradient(90deg, var(--primary), #48a9a6);
    transition: width 0.4s ease;
  }

  &__total,
  &__safety,
  &__income,
  &__normal,
  &__stations {
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
  }

  &__total {
    font-size: 13px;
    font-weight: 600;
    color: var(--text-primary);
    text-align: right;
  }

  &__safety,
  &__income,
  &__normal,
  &__stations {
    font-size: 12px;
    text-align: center;
  }

  &__safety { color: var(--cat-safety); }
  &__income { color: var(--cat-income); }
  &__normal { color: var(--cat-normal); }
  &__stations { color: var(--text-muted); }
}

.card {
  background: var(--card-bg);
  border-radius: 12px;
  border: 1px solid #fff;
  box-shadow: var(--shadow-card);
  backdrop-filter: blur(6px);
  padding: 18px 20px;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.card-loading {
  position: absolute;
  z-index: 2;
  top: 0;
  right: 0;
  left: 0;
}

.card-head {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .sub {
    font-size: 12px;
    color: var(--text-muted);
    font-weight: 400;
  }
}

.card-head__title {
  display: inline-flex;
  min-width: 0;
  align-items: baseline;
}

.chart-order {
  margin-right: 8px;
  color: var(--primary);
  font-size: 10px;
  font-variant-numeric: tabular-nums;
}

.analysis-chart {
  scroll-margin-top: 14px;

  &.is-analysis-focus {
    animation: analysis-chart-focus 1.6s ease;
  }
}

.chart-box {
  height: 300px;
  width: 100%;
  min-height: 300px;
}

.chart-box--eblock {
  height: 340px;
  min-height: 340px;
}

.cluster-chart {
  display: flex;
  flex-direction: column;
}

.cluster-block {
  padding: 10px 8px 10px 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);

  &:last-child {
    border-bottom: none;
  }
}

.cluster-row {
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 16px;
  align-items: center;
}

.cluster-label-group,
.cluster-main-label,
.cluster-visual {
  display: flex;
  align-items: center;
}

.cluster-label-group,
.cluster-main-label,
.cluster-visual {
  gap: 10px;
}

.cluster-main-label {
  flex: 1;
  min-width: 0;
}

.cluster-cat-icon {
  flex-shrink: 0;

  &.cat-safety { color: #FF1E1E; }
  &.cat-income { color: #F59E0B; }
  &.cat-normal { color: #3A68FF; }
}

.alarm-code {
  flex-shrink: 0;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

.alarm-desc {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  color: #2e2e2e;
  font-weight: 500;
}

.visual-bar-area {
  flex: 1;
  min-width: 0;
}

.bar-track {
  height: 16px;
  background: rgba(0, 0, 0, 0.04);
  border-radius: 999px;
  overflow: hidden;
  position: relative;
}

.bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #3A68FF 0%, #6B8CFF 100%);
  display: flex;
  align-items: center;
  padding: 0 8px;
  transition: width 0.4s ease;
  min-width: 52px;
  border-radius: 999px;
}

.bar-label {
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.visual-stats {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
}

.stat-badge {
  display: inline-flex;
  align-items: center;
  padding: 0 8px;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 999px;
  font-size: 11px;
  color: rgba(46, 46, 46, 0.7);
  font-weight: 500;
  white-space: nowrap;
}

@keyframes analysis-chart-focus {
  0%, 35% { background-color: var(--primary-faint); }
  100% { background-color: var(--card-bg); }
}

@media (max-width: 900px) {
  .row-charts {
    grid-template-columns: 1fr;
  }

  .geo-card__body {
    flex-direction: column;
  }

  .geo-card__rank {
    width: 100%;
    border-left: none;
    border-top: 1px solid var(--border);
    padding-left: 0;
    padding-top: 12px;
    max-height: 300px;
  }
}
</style>
